import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import { mergeWebsocketDocuments } from '@freelancer/datastore/core';
import type { PjpAssistantEnqueueCollection } from './pjp-assistant-enqueue.types';

export function pjpAssistantEnqueueReducer(
  state: CollectionStateSlice<PjpAssistantEnqueueCollection> = {},
  action: CollectionActions<PjpAssistantEnqueueCollection>,
): CollectionStateSlice<PjpAssistantEnqueueCollection> {
  switch (action.type) {
    case 'API_PUSH_SUCCESS': {
      if (action.payload.type === 'pjpAssistantEnqueue') {
        const { ref } = action.payload;
        return mergeWebsocketDocuments<PjpAssistantEnqueueCollection>(
          state,
          [],
          ref,
        );
      }
      return state;
    }
    default: {
      return state;
    }
  }
}
